// extracted by mini-css-extract-plugin
export default {"userAvatarBox":"h5_userAvatarBox__pBX1r","avatar":"h5_avatar__HiZsU","official":"h5_official__-p-P8"};